import * as THREE from 'three';
import { ASSETS } from '../scene/assets';
import type { Anclaje } from '../config/types';

/**
 * Materiales PBR de la base de la pérgola según el anclaje (hormigón/tarima/césped).
 * Se cachean las TEXTURAS (no el material): la pérgola libera sus materiales en cada
 * reconstrucción, así que devolvemos un material nuevo que referencia las texturas
 * cacheadas (que persisten y no se recargan).
 */
interface TexSet {
  map: THREE.Texture;
  normalMap: THREE.Texture;
  roughnessMap: THREE.Texture;
}
const texCache = new Map<Anclaje, TexSet>();
const loader = new THREE.TextureLoader();

function getTextures(anclaje: Anclaje): TexSet {
  const existing = texCache.get(anclaje);
  if (existing) return existing;

  const def = ASSETS.surfaces[anclaje];
  const map = loader.load(def.color);
  const normalMap = loader.load(def.normal);
  const roughnessMap = loader.load(def.roughness);
  map.colorSpace = THREE.SRGBColorSpace;
  for (const t of [map, normalMap, roughnessMap]) {
    t.wrapS = THREE.RepeatWrapping;
    t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(def.repeat, def.repeat);
    t.anisotropy = 8;
  }
  const set = { map, normalMap, roughnessMap };
  texCache.set(anclaje, set);
  return set;
}

export function getSurfaceMaterial(anclaje: Anclaje): THREE.MeshStandardMaterial {
  const tex = getTextures(anclaje);
  const mat = new THREE.MeshStandardMaterial({ ...tex, roughness: 1, metalness: 0 });
  mat.name = `surface-${anclaje}`;
  return mat;
}
